import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Facebook domain verification
const meta = document.createElement('meta');
meta.name = 'facebook-domain-verification';
meta.content = 'cloxupdyffbqi010nkr68niq77gxbk';
document.head.appendChild(meta);
render(<App data-id="element-550" />, document.getElementById('root'));